import defaultImage from 'static/img/sections/related-notes/default-1.webp';
import fontStyles from 'styles/Fonts.module.scss';
import Image from 'core/image';
import PropTypes from 'prop-types';
import Spacer from 'core/spacer';
import styles from 'styles/BlogContent.module.scss';
import stylesRandomNote from 'styles/RandomNote.module.scss';

const maxTextLength = 240;
const truncateDescription = (description) => {
    if (description.length > maxTextLength) {
        return description.substring(0, maxTextLength) + '...';
    }
    return description;
};

const RandomNote = ({ item }) => {
    return (
        <a className={styles.note} target="_blank" href={item.url} rel="noreferrer">
            <p
                className={`${fontStyles.text_normal} ${stylesRandomNote.noteRandomTitle}`}
                title={item.title}
            >{item.title}</p>
            <div>
                <Image
                    src={item.image || defaultImage}
                    width={200}
                    height={130}
                    alt={item.title}
                    // Class and style don't have the same effect
                    // cassName={stylesRandomNote.responsiveImage}
                    style={{ width: '100%', height: '100%' }}
                />
            </div>
            <Spacer space={1} />
            <small className={`${fontStyles.text_small} ${stylesRandomNote.randomNoteText}`}>
                {truncateDescription(item.description || '')}
            </small>
        </a>
    );
};

RandomNote.propTypes = {
    item: PropTypes.shape({
        url: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        image: PropTypes.string,
        description: PropTypes.string
    })
};

export default RandomNote;
